// extracted by mini-css-extract-plugin
export default {"wrapper":"SortableTableHead_wrapper__3REfj","th":"SortableTableHead_th__gWL1y","enThead":"SortableTableHead_enThead__eBbMK","ruThead":"SortableTableHead_ruThead__4eHbb"};